/**
 * Created by shubham on 10/5/18.
 */

import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ManagerListDashboard} from "./managerList-datatable/managerList-dashboard";
import {ManagerListPageData} from "./managerList-datatable/managerList-page-data";
import {ManagerListPage} from "./managerList-datatable/managerList-page";

/**
 * A server used to mock a paged data result from a server
 */
@Injectable()
export class ManagerListDashboardResultService {
    listData:any;
    loginData;
    rows = {};
    adminDashboardData = {};

    constructor(){}

    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    public getResults(page: ManagerListPage,listData): Observable<ManagerListPageData<ManagerListDashboard>> {
        this.listData = listData;
        return Observable.of(listData).map(data => this.getPageData(page));
    }

    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    private getPageData(page: ManagerListPage): ManagerListPageData<ManagerListDashboard> {
        let pageData = new ManagerListPageData<ManagerListDashboard>();
        let offset = this.listData.offset;
        let raw = [];
        for(let l in this.listData){
            if(Object.keys(this.listData[l]).length > 0){
                raw[offset+parseInt(l)] = this.listData[l];
            }
        }
        if(this.listData.totalCount){
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        let start = page.pageNumber * page.size;
        let end = Math.min((start + page.size), page.totalElements);
        for (let i = start; i < end; i++) {
            if(raw[i]){
                let jsonObj = raw[i];
                if(jsonObj){
                    let list = new ManagerListDashboard(jsonObj['buAssociationId'], jsonObj['Name'], jsonObj['email'], jsonObj['emailVerified'],
                        jsonObj['userId_WPASS'], jsonObj['pendingSubUserCount'], jsonObj['applicationName'] ,jsonObj['countryId'], jsonObj['countryName'],
                        jsonObj['businessUnitId'], jsonObj['businessUnitName'], jsonObj['active'], jsonObj['status'], jsonObj['createdAt']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/managerAssignment/managerListDashboardResultService.ts